export enum InputTypes {
  TEXT = "TEXT",
  MULTI_LINE_TEXT = "MULTI_LINE_TEXT",
  NUMBER = "NUMBER",
  PHONE_NUMBER = "PHONE_NUMBER",
  EMAIL = "EMAIL",
  PASSWORD = "PASSWORD",
  CURRENCY = "CURRENCY",
  COLOR = "COLOR",
}

export enum NumberInputStepButtonPosition {
  LEFT = "left",
  RIGHT = "right",
  NONE = "none",
}
